import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";

import { ApiObfuscationInterceptor } from "./services/api-obfuscation.interceptor";
import { EncryptionService } from "./services/encryption.service";
import { RouteMappingService } from "./services/route-mapping.service";

@NgModule({
  imports: [CommonModule],
  providers: [
    EncryptionService,
    RouteMappingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiObfuscationInterceptor,
      multi: true
    }
  ]
})
export class ApiObfuscationModule {}
